module.exports = __webpack_public_path__ + "static/feminuity-logo-11ee0e34a494e132afbf01bcecef22a1.png";